<template>
  <div ref="content">
    <Header
      :viewDeals="viewDeals" />
    
    <ModuleMenu 
      :moduleKey="module_key"
      :projectId="projectId"
      @quickViewDeals="viewDeals = !viewDeals"
      :triggerTip="trigger_tip" />

    <div class="listing container_width mt-12">        
      <v-alert
        v-model="show_faved"
        color="secondary"
        border="right"
        dark
        icon="mdi-school"
        prominent
        class="ma-0">
        Your Listing has been favorited and can be found here!
      </v-alert>

      <v-alert
        v-if="showCompleteProfileAlert"
        icon="mdi-bullhorn-variant"
        border="right"
        color="secondary"
        text
        outlined
        prominent
        class="mb-6 sansation_subtitle font-weight-medium">
        Complete your <router-link :to="`/module_questionnaire/${module_key}/${projectId}`" push class="secondary--text text--darken-1">buyer profile</router-link> to be eligible to express interest on listings
      </v-alert>

      <v-row v-if="listing.status == 4 || listing.status == 3">
        <div :style="{'text-align':'center','width':'100%'}">
          <button v-if="listing.status == 4" class="listing-sold-alert">
            <v-icon med :color="'red'">{{icons.bullhorn}}</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;This listing has been sold
          </button>
          <button v-if="listing.status == 3" class="listing-sold-alert">
            <v-icon med :color="'red'">{{icons.bullhorn}}</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;This listing is pending sale
          </button>
        </div>
      </v-row>

      <v-row no-gutters>
        <v-col no-gutters cols="3">
          <ListingHeaderImage
            :image="listing.img"
          />
        </v-col>
        <v-col no-gutters cols="9">
          <ListingHeaderInfo
            :notified="listing.notify"
            :listingId="listing.listing_id"
            :title="listing.title"
            :status="statusName"
            :acceptingFlag="listing.accepting_flag"
            :stage="listing.stage_name"
            :aum="listing.aum"
            :aua="listing.aua"
            :revenue="listing.rev_text"
            :averageFee="listing.revenue_average_fee_charged"
            :type="listing.type_name"
            :practiceType="listing.listing_type"
            :favorited="listing.favorited"
            :interest="listing.interested"
            :canExpress="listing.buyer_status"
            :description="listing.description"
            :price="listing.asking_price"
            :listingStatus="listing.status"
            :t12AsOfDate="listing.t12AsOfDate"
            :t12AsOfValue="listing.t12AsOfValue"
            :downloadProspectus="listing.download_prospectus"
            :insuranceBasedListings="insuranceBasedListings"
            :taxBasedListings="taxBasedListings"
            @download="downloadListing"
            @update="updateListing('interest')"
            @notify="updateListing('notify')"
            @completeProfile="alertCompleteProfile()"
          />
        </v-col>
      </v-row>

      <v-row v-if="listing.status == 2" :style="{'margin':'100px'}">
        <h3 :style="{'margin':'auto'}">More Information Coming Soon!</h3>
      </v-row>

      <v-row no-gutters class="px-4" v-if="![2,3,4].includes(listing.status) && !taxBasedListings.includes(listing.listing_type)">
        <v-col no-gutters v-if="$vuetify.breakpoint.mdAndUp" cols="3" >
          <Navigation
            v-if="readyToLoadDetails"
            class="hide-nav"
            :activeSection.sync="activeSection"
            :title="listing.listing_id"
            @download="downloadListing"
          />
        </v-col>

        <v-col no-gutters cols="9" md="12" lg="9">
          <div class="detail-content-wrapper" v-if="readyToLoadDetails">
            <FullDetailsContent
              :activeSection.sync="activeSection"
              :insuranceBasedListings="insuranceBasedListings"
              :taxBasedListings="taxBasedListings"
              :allListOptions="all_lists"
              :listing="listing"
            />
          </div>
        </v-col>
      </v-row>
    </div>

    <v-dialog
      v-if="showShareDialog"
      :value="true"
      max-width="390"
      @click:outside="showShareDialog = null"
    >
      <v-card>
        <v-card-title class="headline">
          Share Listing
        </v-card-title>

        <v-card-text>
          <v-form ref="shareDialogForm" @submit.prevent="shareListing(true)">
            <v-text-field
              v-model="showShareDialog.email"
              label="Send listing to this email"
              :rules="[
                ...validationRules.required,
                ...validationRules.email
              ]"
              validate-on-blur
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!showShareDialog.email"
            @click="shareListing(true)"
          >
            Send
          </v-btn>
          <v-btn
            color="error"
            @click="showShareDialog = null"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
	import axios from "axios";
  import Cookie from "js-cookie";
	import formMixin from '@/mixins/forms'

	import appUrls from '../helpers/environment';
	import router from '../router';
	import {
		mdiMagnify,
		mdiChevronDown,
		mdiChevronUp,
		mdiChevronDoubleRight,
		mdiFacebookBox,
		mdiLinkedinBox,
		mdiTwitterBox,
		mdiEmailVariant,
		mdiHeartCircleOutline,
		mdiBullhorn
	} from '@mdi/js';

	// let dateFormat = require('dateformat');
	import dateFormat, { masks } from "dateformat";

	import AdvisorInsights from '@/assets/The_Buy_Side_Experience_With_SRG.png'

	import Header from './Header'
	import ModuleMenu from './ModuleMenu'
	import {
		toDollarsListings,
		dynamicTitle
	} from './utilities';

	import BuyerDescription from './buyer-listing-details/buyer-description'
	import FullDetailsContent from './buyer-listing-details/full-details-content'
	import ListingHeaderImage from './buyer-listing-details/header-image'
	import ListingHeaderInfo from './buyer-listing-details/header-info'
	import Navigation from './buyer-listing-details/Navigation'
	import NextSteps from './buyer-listing-details/next-steps'

	export default {
	name: 'ListingDetail',
	
	mixins: [formMixin],
	
	components: {
		Header,
		ModuleMenu,
		BuyerDescription,
		FullDetailsContent,
		ListingHeaderImage,
		ListingHeaderInfo,
		Navigation,
		NextSteps,
	},

	data () {
		return {
			module_key: 'buyer',
      projectId: '',
			readyToLoadDetails: false,
      showCompleteProfileAlert: false,
			listing: [],
			insuranceBasedListings: [8], // 3,7
      taxBasedListings: [10],
			advisorInsights: AdvisorInsights,
			icons: {
				bullhorn: mdiBullhorn,
				chevronDownIcon: mdiChevronDown,
				chevronUpIcon: mdiChevronUp,
				chevronDoubleRightIcon: mdiChevronDoubleRight,
				magnifyIcon: mdiMagnify,
				socialFacebook: mdiFacebookBox,
				socialLinkedIn: mdiLinkedinBox,
				socialTwitter: mdiTwitterBox,
				socailEmail: mdiEmailVariant,
				heartCircleIcon: mdiHeartCircleOutline
			},
			listing_statuses: [
				{
				value: 1,
				text: 'Open',
				filter: 'open_listings'
				},
				{
				value: 2,
				text: 'Coming Soon',
				filter: 'coming_listings'
				},
				{
				value: 3,
				text: 'Pending',
				filter: 'pending_listings'
				},
				{
				value: 4,
				text: 'Sold',
				filter: 'sold_listings'
				},
			],

			getDisqualifiedBuyerStatusIds: [21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],

			offer_type: '',
			offer_text: '',

			buyerprofile_status: false,
			buyerxinterest_status: false,
			show_faved: false,
			trigger_tip: false,
			activeSection: 'content-seller-info',

			// actionDialog: false,
			// actionMessage: '',
			// actionColor: 'error',
			// actionDuration: 6000,

			showShareDialog: false,
			viewDeals: false,
			all_lists: [],
			states: [],
			buyer_status: [],
			listing_types: [],
			listing_stages: [],
			communication_methods: [],
			
			authUser: {
				id: String,
				is_secondary: Boolean
			}
		}
	},

    computed: {
      statusName () {
        if (!this.listing_statuses || !this.listing) return ''

        return (
          this.listing_statuses.find(({ value }) => parseInt(value) === this.listing.status) ||
          {}
        ).text || ''
      }
    },

    watch: {
        dialog(val) {
            val || this.close()
        }
    },

    created () {
      document.title = dynamicTitle( 'Buyer listing: ', this.$route.params )
      this.getLists()
    },

    async mounted () {
      await this.getUserData()
      await this.getListingDetail()
    },

	methods: {

    loadHubSpotTrackingCode: function () {
      try {
        if ( appUrls.mycompass.includes('mycompass') ) {
          const script = document.createElement('script')
          script.src = '//js.hs-scripts.com/6155808.js'
          script.async = true
          script.defer = true
          document.body.appendChild(script)
        }
      } catch (error) {
				console.error(error);
			}
    },

		formatDate: function ( date, mask ) {
			return dateFormat(date, mask)
		},

    alertCompleteProfile: function () {
      this.showCompleteProfileAlert = true
    },

    checkUser: async function () {
			try {
				const user_check = await axios.get(`${appUrls.api}/api/user_check`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
				})
			 
				if ( user_check.data.outcome ) {    
					this.authUser.id = user_check.data.user_data.id
					this.authUser.is_secondary = user_check.data.user_data.is_secondary
				} else {
					console.log(user_check.data.message)
				}
			} catch (error) {
				console.error(error);
			}
		},

		getUserData: async function () {
			try {
				await this.checkUser()
				const response = await axios.get(`${appUrls.api}/api/profile_status/${this.authUser.id}`, {
					headers: {
						authentication: Cookie.get('token'),
						"Content-Type": "application/json"
					}
				})

				if (response.data.outcome) {
					this.buyerprofile_status = ['complete', 'completed',].includes(response.data.status)
          this.projectId = response.data.project
				}
			} catch (error) {
				console.error(error);
			}
		},

      getListingDetail: async function () {
        //console.log(this.$route.params.lid)
        await axios.post(`${appUrls.api}/api/listing_detail/${this.$route.params.lid}`, {
            headers: {
              authentication: Cookie.get('token'),
              "Content-Type": "application/json"
            },
            data: {
              'user_id': Cookie.get('id'),
              'is_secondary': this.authUser.is_secondary
            }
        })
        .then(res => {

            if (res.data.outcome) {
                this.listing = res.data.listing;
                // console.log(res.data.user_interest.length)
                if (res.data.user_interest.length) {
                  this.listing.notify = res.data.user_interest[0].notify ? 'notified' : null;
                  this.listing.buyer_status = this.getDisqualifiedBuyerStatusIds.includes(res.data.user_interest[0].status_id) ? false : true;
                } else {
                  this.listing.notify = null;
                  this.listing.buyer_status = this.buyerprofile_status;
                }

                this.listing.listing_type   = this.listing.listing_type != null ? parseInt(this.listing.listing_type) : 0;
                this.listing.status         = this.listing.status != null ? parseInt(this.listing.status) : 0;
                this.listing.stage          = this.listing.stage != null ? parseInt(this.listing.stage) : 0;
                this.listing.title          = this.listing.title != null ? this.listing.title : '[No Title]';
                this.listing.download_prospectus = this.listing.pdf_last_gen_date != null ? true : false;

                // ASKING PRICE
                this.listing.asking_price = '$'+new Intl.NumberFormat('en-US').format(this.listing.asking_price)
                
                // AUM TEXT
                let aum_text
                if (Number.parseFloat(this.listing.aum) >= 1000000) {
                    aum_text = Number.parseFloat(this.listing.aum / 1000000).toFixed(2)
                    this.listing.aum_text = '$'+aum_text.replace(/\.?0*$/,'')+'M'
                } else {
                    aum_text = Number.parseFloat(this.listing.aum)
                    this.listing.aum_text = toDollarsListings(Number.parseFloat(this.listing.aum))
                }
                
                // CHANGED TO ACCOMODATE FOR SAFARI'S MISHANDLING OF JAVASCRIPT'S Date.parse()
                this.listing.postDateYear = this.formatDate(this.listing.post_date, 'yyyy')
                this.listing.t12AsOfYear = this.listing.revenue_t12_asof_date ? this.formatDate(this.listing.revenue_t12_asof_date, 'yyyy') : '';
                this.listing.t12AsOfDate = this.listing.revenue_t12_asof_date ? this.formatDate(this.listing.revenue_t12_asof_date, 'mm/dd/yyyy') : '';
                
                this.listing.post_date = this.formatDate(this.listing.post_date, 'yyyy-dd-mm')
                this.listing.revenue_t12_asof_date = this.listing.revenue_t12_asof_date ? this.formatDate(this.listing.revenue_t12_asof_date, 'mm/dd/yyyy') : '';

                // REVENUE TEXT                  
                if (Number.parseFloat(this.listing.revenue) >= 1000000) {
                  let rev_text = Number.parseFloat(this.listing.revenue / 1000000).toFixed(2)
                  // this.listing.rev_text = '$'+rev_text.replace(/\.?0*$/,'')+'M'
                  this.listing.rev_text = `$${rev_text.replace(/\.?0*$/,'')} ${Number.parseFloat(this.listing.revenue) >= 1000000000 ? 'Billion' : 'Million'}`
                } else {
                  this.listing.rev_text = toDollarsListings(Number.parseFloat(this.listing.revenue))
                }

                // REVENUE TEXT IF revenue_t12_asof_date
                if ( this.listing.revenue_t12_asof_date ) {
                  if (Number.parseFloat(this.listing.revenue_t12_months) >= 1000000) {
                    let revt12value_text = Number.parseFloat(this.listing.revenue_t12_months / 1000000).toFixed(2)
                    this.listing.t12AsOfValue = `$${revt12value_text.replace(/\.?0*$/,'')} ${Number.parseFloat(this.listing.revenue_t12_months) >= 1000000000 ? 'Billion' : 'Million'}`

                    // this.listing.t12AsOfValue = this.$options.filters.currency(this.listing.revenue_t12_months, false, true)
                  } else {
                    this.listing.t12AsOfValue = toDollarsListings(Number.parseFloat(this.listing.revenue_t12_months))
                  }
                } else {
                  this.listing.t12AsOfValue = ''
                }

                this.listing.listing_type = parseInt(this.listing.listing_type);
                this.listing.status = parseInt(this.listing.status);

                // IMAGE
                if (this.listing.custom_image != null ) {
                    this.listing.img = require(`@/assets/listings/custom/${this.listing.custom_image}`);
                } else {
                    this.listing.img = require(`@/assets/listings/states/${this.listing.state}.jpg`);
                }

                // TYPE NAME
                if ( this.listing.listing_type != 0 ) {
                  let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.listing.listing_type);
                  this.listing.type_name = typeObj.text;
                } else {
                  this.listing.type_name = '[Not Defined]';
                }

                // STAGE NAME
                if ( this.listing.stage != 0 ) {
                  let stageObj = this.listing_stages.find(obj => parseInt(obj.value) === this.listing.stage);
                  this.listing.stage_name = stageObj.text;
                } else {
                  this.listing.stage_name = '[Not Defined]';
                }

                // LOOK TO SEE IF THERE IS EVEN ANY RECORDS IN jbuyerstolistings FOR THIS USER & LISTING
                let has_record = res.data.user_interest.length >= 1 ? true : false;

                // INTERESTED
                this.listing.favorited = !!has_record
                this.listing.interested = has_record ? res.data.user_interest[0].interest ? true : false : false;

                // OFFER
                this.listing.offer_made = has_record ? res.data.user_interest[0].offer ? true : false : false;
                this.offer_type = has_record ? res.data.user_interest[0].offer ? "warning" : "primary" : "primary";
                this.offer_text = has_record ? res.data.user_interest[0].offer ? 'Offer Made' : 'Make An Offer' : 'Make An Offer';

                this.readyToLoadDetails = true;
                //console.log(this.listing)
            }
        })
        .catch((error) => {
            console.log(error);
            router.replace({ path: '/buyer_listings?error=listing_not_found' })
        });
      },

      async getLists() {
          let optionsLists = [{
              'name': 'listing_types',
              'type': 'int'
          }, {
              'name': 'listing_stages',
              'type': 'int'
          },{
              'name': 'buyer_status',
              'type': 'int'
          }, {
              'name': 'states',
              'type': 'txt'
          }, {
              'name': 'communication_methods',
              'type': 'txt'
          }];
          
          axios.post(`${appUrls.api}/api/lists`, {
              headers: {
                  authentication: Cookie.get('token'),
                  "Content-Type": "application/json"
              },
              list_options: optionsLists
          })
          .then(res => {
              //console.log(res.data)
              if (res.data.outcome) {
                  let arrLists = res.data.lists;
                  this.all_lists = arrLists;
                  // SET PROPERTIES WITH THIER APPROPRIATE LIST
                  for (let l in arrLists) {
                      if (arrLists[l].name == 'states') this.states = arrLists[l].list
                      if (arrLists[l].name == 'buyer_status') this.buyer_status = arrLists[l].list
                      if (arrLists[l].name == 'listing_stages') this.listing_stages = arrLists[l].list
                      if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                      if (arrLists[l].name == 'communication_methods') this.communication_methods = arrLists[l].list
                  }
              }
          })
          .catch(function(error) {
              console.log(error);
          });
      },

      async updateListing (action) {
        // console.log(action+': ', this.buyerprofile_status)
        let update_listing = true;
        if ( action === 'interest' && !this.buyerprofile_status ) {
          update_listing = false;
        }

        if ( update_listing ) {
          axios.post(`${appUrls.api}/api/update_listing`, {
            headers: {
              authentication: Cookie.get('token'),
              "Content-Type": "application/json"
            },
            data: {
              'user_id': Cookie.get('id'),
              'listing_id': this.listing.id,
              'action': action,
              'su': Cookie.get('sugar')
            }
          })
          .then(res => {
              if (res.data.outcome) {
                this.getListingDetail()
                if (action == 'fav') this.show_faved = true
                if (action == 'interest') {
                  this.trigger_tip = !this.trigger_tip
                  // this.loadHubSpotTrackingCode()
                }
              } else {

              }
          })
          .catch(function(error) {
              console.log(error);
          });
        } else {
          console.log('Buyer Profile Not Complete');
          router.push({ path: `/how_to_express_interest/${this.module_key}` })
        }

      },

      async downloadListing  () {
        window.open(`${appUrls.api}/api/listing-details-pdf/${this.listing.listing_id}`, `_blank`)
      },

      async shareListing (confirmed = false) {
        if (!confirmed) {
          this.showShareDialog = { email: '' }
          return
        }

        if (!this.$refs.shareDialogForm.validate()) return

        const link = `${appUrls.api}/api/listing-details-pdf/${this.listing.listing_id}`
        const query = `?email=${this.showShareDialog.email}`

        this.showShareDialog = null

        try {
          const response = await axios.get(`${link}${query}`)
          console.log('share sent successfully')
        } catch (error) {
          console.error('error sharing listing', error)
        }
      },
    },
}
</script>

<style scoped>
.listing {
  background-color: #EFEFEF;
  min-height: 70vh;
}

@media screen and (max-width: 1264px) {
  .detail-content-wrapper {
    overflow-x: auto;
  }
  .hide-nav {
    display: none;
  }
  .row {
    margin-left: unset;
    margin-right: unset;
  }
}


label {
  font-weight: 500;
  text-decoration-line: underline;
}

a.button_link {
  text-decoration-line: none
}

.menu_borders {
  border-bottom: 2px solid #FFF;
}

.listing-sold-alert {
  cursor: default;
  color: red;
  padding: 15px 25px;
  border: 2px solid red;
  margin-bottom: 60px;
  border-radius: 5px;
  text-transform: uppercase;
  font-family: 'Sansation', sans-serif;
  outline:none;
}
</style>



// WEBPACK FOOTER //
// src/components/ListingDetail.vue